/* eslint-disable tailwindcss/no-arbitrary-value */
import React from 'react';
import proptypes from 'prop-types';
const { string } = proptypes;
import classnames from 'classnames';
import { useApplianceBundles } from '../ApplianceBundlesProvider';

export const Symbol = ({ symbol }) => {
  const { hasMobileView, hasTabletView } = useApplianceBundles();

  const symbolClassNames = classnames('sui-font-bold sui-text-8xl sui-flex sui-items-center', {
    'sui-p-4': !hasMobileView,
    'sui-mx-auto sui-leading-none': hasMobileView
  });

  return (
    <div className={classnames({
      'sui-pr-2': !(hasMobileView || hasTabletView),
      'sui-m-auto': hasMobileView,
      'sui-leading-[19.5em]': !hasMobileView
    })}
    >
      <div className={symbolClassNames}>
        {symbol}
      </div>
    </div>
  );
};

Symbol.propTypes = {
  symbol: string.isRequired
};
